// extracted by mini-css-extract-plugin
export default {"mn-sample-admin-modal":"index_mn-sample-admin-modal__LouYS"};